import * as Styles from "./styles";
import { Modal, Button } from "antd";

export interface OkPopupProps {
  visible: boolean;
  isCloseOkPopup: () => void;
  isCancel: () => void;
  errorMessage: string
}

export default function OkPopup({
  visible,
  isCloseOkPopup,
  isCancel,
  errorMessage
}: OkPopupProps) {
  return (
    <Styles.Container>
      <Modal
        wrapClassName="operator"
        open={visible}
        onOk={isCloseOkPopup}
        onCancel={isCancel}
        closable={true}
        footer={[
          <Button key="submit" type="primary" onClick={isCloseOkPopup}>
            Okay
          </Button>
        ]}
      >
        <Styles.Content>
          {errorMessage || "Already Picked Order"}
        </Styles.Content>
      </Modal>
    </Styles.Container>
  );
}
